import { Grid, Skeleton } from '@design-systems/canvas-ui'

type BasicPlaceholderType = {
    type?: 'text' | 'table' | 'rect'
    rows?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
    columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
    height?: string
}

export const BasicPlaceholder = ({
    type = 'text',
    rows = 1,
    columns = 1,
    height = '55px',
}: BasicPlaceholderType) => {
    if (type === 'text') {
        return <BasicPlaceholder.Text rows={rows} />
    }

    if (type === 'table') {
        return <BasicPlaceholder.Table rows={rows} columns={columns} />
    }

    if (type === 'rect') {
        return <BasicPlaceholder.Rect height={height} />
    }

    return null
}

BasicPlaceholder.Text = ({ rows = 1 }: BasicPlaceholderType) => {
    return (
        <Grid.Container spacing="none" className="hc8-pa-4x">
            <Grid.Item
                size={{
                    xs: 12,
                }}
            >
                {Array.from({ length: rows }, (_, index) => (
                    <div
                        key={index}
                        style={{ marginBottom: index === rows - 1 ? 0 : 8 }}
                    >
                        <Skeleton variant="rectangle" height="14px" />
                    </div>
                ))}
            </Grid.Item>
        </Grid.Container>
    )
}

BasicPlaceholder.Table = ({ rows = 5 }: BasicPlaceholderType) => {
    return (
        <div className="hc8-pa-4x">
            {Array.from({ length: rows }, (_, rowIndex) => (
                <div
                    key={rowIndex}
                    style={{
                        marginBottom: rowIndex === rows - 1 ? 0 : 12,
                    }}
                >
                    <Skeleton variant="rectangle" height="18px" />
                </div>
            ))}
        </div>
    )
}

BasicPlaceholder.Rect = ({ height = '55px' }: BasicPlaceholderType) => {
    return (
        <Grid.Container>
            <Grid.Item
                size={{
                    xs: 12,
                }}
            >
                <Skeleton variant="rectangle" height={height} />
            </Grid.Item>
        </Grid.Container>
    )
}
